import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Emr } from '@models/emr.model';

export const EmrActions = createActionGroup({
  source: 'Emr',
  events: {
    'Load Emrs': emptyProps(),
    'Load Emrs Success': props<{ emrs: Emr[] }>(),
    'Load Emrs Failure': props<{ error: string }>(),
  }
});
